// extracted by mini-css-extract-plugin
export default {"tabs":"ChartCard_tabs__Y3sYj","tabBtn":"ChartCard_tabBtn__cM0XC","active":"ChartCard_active__Ne5m-"};